import { AvatarSize } from "@faire/web/slate-deprecated/Avatar";

export const TOP_SHOP_ICON = "TOP_SHOP_ICON";

export const ICON_SIZE_MAP: Record<AvatarSize, string> = {
  "xx-small": "16px",
  "x-small": "16px",
  smaller: "16px",
  small: "16px",
  medium: "22px",
  large: "22px",
  "x-large": "22px",
};
